var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataSource } from '@angular/cdk/collections';
import { map } from 'rxjs/operators';
import { of as observableOf, merge } from 'rxjs';
// TODO: replace this with real data from your application
// const EXAMPLE_DATA: TableItem[] = [
//  id: 1, name: 'Hydrogen' },
//  id: 2, name: 'Helium' },
//  id: 3, name: 'Lithium' },
//  id: 4, name: 'Beryllium' },
//  id: 5, name: 'Boron' },
//  id: 6, name: 'Carbon' },
//  id: 7, name: 'Nitrogen' },
//  id: 8, name: 'Oxygen' },
//  id: 9, name: 'Fluorine' },
//  id: 10, name: 'Neon' },
//  id: 11, name: 'Sodium' },
//  id: 12, name: 'Magnesium' },
//  id: 13, name: 'Aluminum' },
//  id: 14, name: 'Silicon' },
//  id: 15, name: 'Phosphorus' },
//  id: 16, name: 'Sulfur' },
//  id: 17, name: 'Chlorine' },
//  id: 18, name: 'Argon' },
//  id: 19, name: 'Potassium' },
//  id: 20, name: 'Calcium' },
// ];
var SCORE_CHART = [
    { scoreRange: '0-5', grade: 'Perfect' },
    { scoreRange: '5-10', grade: 'Excellent' },
    { scoreRange: '10-15', grade: 'Great' },
    { scoreRange: '15-20', grade: 'Very Good' },
    { scoreRange: '20-25', grade: 'Good' },
    { scoreRange: '25-30', grade: 'Okay' },
    { scoreRange: '30-35', grade: 'Almost' },
    { scoreRange: '35-40', grade: 'Not Too Good' },
    { scoreRange: '40+', grade: 'No Effort' },
];
/**
 * Data source for the Table view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
var TableDataSource = /** @class */ (function (_super) {
    __extends(TableDataSource, _super);
    function TableDataSource() {
        var _this = _super.call(this) || this;
        _this.data = SCORE_CHART;
        return _this;
    }
    /**
     * Connect this data source to the table. The table will only update when
     * the returned stream emits new items.
     * @returns A stream of the items to be rendered.
     */
    TableDataSource.prototype.connect = function () {
        var _this = this;
        // Combine everything that affects the rendered data into one update
        // stream for the data-table to consume.
        var dataMutations = [
            observableOf(this.data),
        ];
        // Set the paginator's length
        // this.paginator.length = this.data.length;
        return merge.apply(void 0, dataMutations).pipe(map(function () {
            // return this.getPagedData(this.getSortedData([...this.data]));
            return _this.data;
        }));
    };
    /**
     *  Called when the table is being destroyed. Use this function, to clean up
     * any open connections or free any held resources that were set up during connect.
     */
    TableDataSource.prototype.disconnect = function () { };
    return TableDataSource;
}(DataSource));
export { TableDataSource };
/** Simple sort comparator for example ID/Name columns (for client-side sorting). */
function compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
